/**
 * Groups an array of objects by a specific key.
 * @param array - The array of objects to be grouped.
 * @param key - The key used to group the objects.
 * @returns An object where each key corresponds to a unique value from the specified key in the objects,
 *          and the value is an array of objects with the same value for the specified key.
 */
export function groupBy<Type extends Record<string, any>>(array: Type[], key: string): {[index:string]:Type[]} {
    return array.reduce((rv: any, x) => {
        rv[x[key]] = rv[x[key]] || []
        rv[x[key]].push(x);
        return rv;
    }, {});
}